// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"154":"9b3f6ec8","633":"33b7f54d"}[chunkId] + ".chunk.js";
};